import { createReducer } from "../../../../../common/reduxUtil";
import {
  USER_LIST_UPDATE_GAMEPLAYER_BASIC_PROFILE,
  USER_LIST_UPDATE_GAMEPLAYER_COMMON_TOPICS,
  USER_LIST_UPDATE_GAMEPLAYER_EXPIRES_AT,
  CLEAR_USER_LIST_STATE,
  UPDATE_USER_LIST_STATE,
  UPDATE_REQUEST_USER_FOLLOWER_LIST_STATE,
} from "./types";

const initialState = {};

/**
 * Schema:
 * // For every game player with the gamePlayerId id x, we maintain the following map:
 * x : {
 *    basic: {}, // game player's basic profile
 *    common: {
 *      3: [], // interested in
 *      7: [], // knows about
 *    }, // common topics with the logged in game player
 *    expiresAt: Date.now + 15 minutes
 * }
 */

const updateUserProfileForKey = (key, state, userId, payload) => {
  const userData = state[userId];
  switch (key) {
    case "basic":
      return {
        [userId]: {
          basic: { ...payload },
        },
      };

    case "connectionDetails":
      return {
        [userId]: {
          ...userData,
          basic: {
            ...userData.basic,
            interrelation: {
              ...userData.basic.interrelation,
              connectionDetails: {
                ...userData.basic.interrelation,
                ...payload,
              },
            },
          },
        },
      };

    case "requestUserFollower":
      return {
        [userId]: {
          basic: {
            ...userData.basic,
            interrelation: {
              ...userData.basic.interrelation,
              isRequestUserFollowing: { ...payload },
            },
          },
        },
      };
    default:
      return {
        [userId]: {
          ...userData,
          [key]: typeof payload === "object" ? { ...payload } : payload,
        },
      };
  }
};

export default createReducer(initialState, {
  [USER_LIST_UPDATE_GAMEPLAYER_BASIC_PROFILE]: (state, { userId, profile }) => {
    return Object.assign(
      {},
      state,
      updateUserProfileForKey("basic", state, userId, profile)
    );
  },
  [USER_LIST_UPDATE_GAMEPLAYER_COMMON_TOPICS]: (state, { userId, topics }) => {
    return Object.assign(
      {},
      state,
      updateUserProfileForKey("common", state, userId, topics)
    );
  },
  [USER_LIST_UPDATE_GAMEPLAYER_EXPIRES_AT]: (state, { userId, expiresAt }) => {
    return Object.assign(
      {},
      state,
      updateUserProfileForKey("expiresAt", state, userId, expiresAt)
    );
  },
  [CLEAR_USER_LIST_STATE]: () => {
    return initialState;
  },
  [UPDATE_USER_LIST_STATE]: (state, payload) => {
    const { gamePlayerId, connectionDetails } = payload;
    return Object.assign(
      {},
      state,
      updateUserProfileForKey(
        "connectionDetails",
        state,
        gamePlayerId,
        connectionDetails
      )
    );
  },
  [UPDATE_REQUEST_USER_FOLLOWER_LIST_STATE]: (state, payload) => {
    const { gamePlayerId, followStatus } = payload;
    return Object.assign(
      {},
      state,
      updateUserProfileForKey(
        "requestUserFollower",
        state,
        gamePlayerId,
        followStatus
      )
    );
  },
});
